// @ts-nocheck
import React , {useEffect , useState} from "react";
import Typography from '@mui/material/Typography';
import NoticeList from "./lists/NoticeList";
import Avatar from '@mui/material/Avatar';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SinapTheme from "../styles/SinapTheme";
import { CheckAll } from "../Componentes/Icons";
import { useBody } from "./state/BodyContext";
import localStorageManagement from "../Security/LocalStorageManagement";
import KeyCloak from "../Auth/Keycloak";
import {ExpandAvatar, PaddingDiv} from "./Home";
import Zoom from '@mui/material/Zoom';
import {useAuth} from "../Auth/State/AuthContext";
import SinapThemev2 from "../styles/SinapThemev2";
import NoticiasHome from "./NoticiasHome";

export default function Notices({time}) {

    const [checked, setChecked] = useState(false);
    const { notices , setNoticesNotViews , noticesNotViews, setMessage } = useBody();
    const {user,isLogedIn} = useAuth();
    const handleChange = () => {
      setChecked((prev) => !prev);
    };

    useEffect(() => {
        setTimeout(() => {
            handleChange()
        }, time);
    },[]);

    const seeAllNews = () => {
        if (notices !== null) {
            notices.forEach(notice => {
                localStorageManagement.addNoticeView(notice.noticia);
            });
            setNoticesNotViews([]);
        } else setMessage("Hubo un error al querer mostrar las cartas con los servicios")
    }
    
    const viewCheckALlViews = () => {
        return KeyCloak.isLoggedIn() && isLogedIn() && noticesNotViews.length > 0;
    }

    return(
        <>
        {
            <PaddingDiv>
                <NoticiasHome notices={notices} loading={false}/>
            </PaddingDiv>
        }
        </>
    );
}